import { Form, Input } from "antd";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import styles from './_RegulatorioFiltroForm.less';
import { SearchOutlined } from "@ant-design/icons";
import { regulatorioFiltroAplicar, regulatorioFiltroSelector } from "../../../store/regulatorioFiltro";
import { useSelector } from "react-redux";
import { acessoSelector } from "../../../store/acessos";
import ActionButton from "../../../components/action-button";
import { fetchEmpresas } from "../../../store/empresas";
import useLoading from "../../../hooks/useLoading";

export default function RegulatorioFiltroForm() {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const loading = useLoading(fetchEmpresas.typePrefix);
  const filtro = useSelector(regulatorioFiltroSelector);
  const acesso = useSelector(acessoSelector);
  const acessoId = acesso?.id;

  useEffect(() => {
    if (!filtro.inicializado) {
      if (acessoId)
        dispatch(regulatorioFiltroAplicar({ search: '' }));
    }
  }, [])

  useEffect(() => {
    form.setFieldsValue(filtro);
  }, [filtro])

  const handleFinish = useCallback(values => {
    dispatch(regulatorioFiltroAplicar(values));
    dispatch(fetchEmpresas({ search: values.search, acessoId, modulo: 'regulatorio' }));
  }, [acessoId]);

  return (
    <Form form={form} noValidate initialValues={filtro} onFinish={handleFinish}>
      <div className={styles.RegulatorioFiltroForm}>
        <div className={styles.search}>
          <Form.Item name="search" noStyle>
            <Input autoFocus/>
          </Form.Item>
        </div>
        <div>
          <ActionButton primary icon={<SearchOutlined/>} loading={loading} htmlType="submit">
            {t('Pesquisar')}
          </ActionButton>
        </div>
      </div>
    </Form>
  )
}
